import React from "react";
import { Typography } from "antd";
import { useSelector } from "react-redux";

const { Title, Text, Link } = Typography;

function Landing() {
  const auth = useSelector((state) => state.auth);
  return (
    <div>
      <div style={{ maxWidth: "1000px", margin: "auto" }}>
        <Title level={4}>
          PROCEDURE FOR VOTING AND PARTICIPATION VIA REMOTE COMMUNICATION
        </Title>
        <Text>
          Megawide Construction Corporation (the “Company”) shall be conducting
          its 2022 Special Stockholders’ Meeting on 20 December 2022, at 1:00
          P.M via remote communication (the “2022 SSM”). In this regard, the
          stockholders of record as of 18 November 2022 (“Stockholders”), shall
          be entitled to attend, participate, and vote in the 2022 SSM, in
          accordance with the procedure outlined below:
        </Text>
        <br />
        <br />
        <ol type="I">
          <li className="tabbed">
            <Text strong underline>
              VOTING IN ABSENTIA
            </Text>
            <ol type="1">
              <li className="tabbed spacing">
                <Text>
                  The Stockholders who would like to vote in absentia shall
                  register at{" "}
                  <Link
                    href={window.location.protocol + "/PreRegistration2022ASM"}
                    underline
                  >
                    Pre-Registration for 2022 SSM
                  </Link>{" "}
                  from <Text strong>25 November 2022 to 13 December 2022</Text>,
                  where they will be asked to provide the following information:
                </Text>
                <ol type="a">
                  <li className="tabbed spacing">
                    <Text strong>For individual Stockholders:</Text>
                    <ol type="i">
                      <li className="tabbed">Full name;</li>
                      <li className="tabbed">Address; </li>
                      <li className="tabbed">Birthdate; </li>
                      <li className="tabbed">Email address; </li>
                      <li className="tabbed">Phone number; </li>
                      <li className="tabbed">Mobile number; </li>
                      <li className="tabbed">
                        Current photograph, with face fully visible;{" "}
                      </li>
                      <li className="tabbed">
                        Scanned copy of valid government-issued ID; and{" "}
                      </li>
                      <li className="tabbed">
                        For Stockholders with joint accounts, a scanned copy of
                        an authorization letter signed by the other
                        Stockholders, indicating who among them is authorized to
                        cast the vote for the account.{" "}
                      </li>
                    </ol>
                  </li>
                  <li className="tabbed spacing">
                    <Text strong>For corporate Stockholders:</Text>
                    <ol type="i">
                      <li className="tabbed">Corporate Name; </li>
                      <li className="tabbed">Address; </li>
                      <li className="tabbed">Email address; </li>
                      <li className="tabbed">Phone number; </li>
                      <li className="tabbed">Mobile number; </li>
                      <li className="tabbed">
                        Scanned copy of the Secretary’s Certificate or Board
                        Resolution authorizing the representative of the
                        corporation to cast the vote;{" "}
                      </li>
                      <li className="tabbed">
                        Current photograph of the representative authorized to
                        cast the vote for the corporation, with face fully
                        visible; and{" "}
                      </li>
                      <li className="tabbed">
                        Scanned copy of valid government-issued ID of the
                        authorized representative.  {" "}
                      </li>
                    </ol>
                  </li>
                  <li className="tabbed">
                    <Text strong>
                      For Stockholders under PCD Participant/Brokers Account of
                      “Scripless Shares”:
                    </Text>
                    <ol type="i">
                      <li className="tabbed">Name; </li>
                      <li className="tabbed">Address; </li>
                      <li className="tabbed">Email address; </li>
                      <li className="tabbed">Phone number; </li>
                      <li className="tabbed">Mobile number; </li>
                      <li className="tabbed">
                        Scanned copy of valid government-issued ID; and
                      </li>
                      <li className="tabbed">
                        Certificate of shareholdings issued by the broker.
                      </li>
                    </ol>
                  </li>
                </ol>
                <br />
                <Text>
                  The submissions of Stockholders shall immediately be validated
                  by the stock transfer agent of the Company, Stock Transfer
                  Service, Inc., in coordination with the Corporate Secretary.
                </Text>
              </li>
              <li className="tabbed spacing">
                <Text>
                  Upon validation, a Stockholder shall be sent a username and
                  password to the email address he/she has provided during
                  registration. The Stockholder shall use this username and
                  password to log in to the voting page at{" "}
                  <Link
                    href={
                      auth.isLoggedIn
                        ? window.location.protocol + "/Voting2022ASM"
                        : window.location.protocol + "/login"
                    }
                    underline
                  >
                    Voting for 2022 SSM
                  </Link>{" "}
                  to be able to cast his/her vote in all the matters included in
                  the agenda of the Company’s 2022 SSM.{" "}
                </Text>
                <br />
                <br />
                <Text>
                  When a Stockholder has finished voting, he/she shall be a
                  shown a summary of the votes he/she has cast. If the
                  Stockholder is satisfied, he/she may click the “Submit”
                  button; otherwise, the Stockholder may click the “Back” button
                  to make any desired changes in his/her votes.{" "}
                </Text>
                <br />
                <br />
                <Text strong>
                  Registered Stockholders shall be allowed to vote until 11:59
                  P.M. of 13 December 2022. The votes shall be considered cast
                  for all the shares of the Stockholder.
                </Text>
                <Text>
                  {" "}
                  The votes shall be considered cast for all the shares of the
                  Stockholder.{" "}
                </Text>
              </li>
              <li className="tabbed spacing">
                <Text>
                  The Stockholders who register and vote in absentia are deemed
                  to have given their permission to the collection, use,
                  transfer, disclosure, sharing, storage, and other forms of
                  processing (collectively “Processing”), by the Company or any
                  relevant third party, of the personal data they have provided.
                  The Processing of the Stockholders personal data shall be used
                  for the purpose of voting in absentia during the 2022 SSM,
                  including for any reason necessary or incidental thereto.{" "}
                </Text>
              </li>
            </ol>
          </li>
          <li className="tabbed">
            <Text strong underline>
              VOTING BY PROXY
            </Text>
            <br />
            <Text>
              The Stockholders of the Company may also vote by completing the
              proxy form attached to the Information Statement (or downloadable
              under Section V1). The completed and signed proxy form shall be
              submitted by the Stockholder to the Company’s stock transfer
              agent, through electronic mail and/or personal service, from{" "}
              <Text strong>25 November 2022 to 13 December 2022</Text>. Please
              refer to the details provided below:{" "}
            </Text>
            <br />
            <br />
            <Text>Through Electronic Mail: </Text>
            <br />
            <Text strong>STOCK TRANSFER SERVICE, INC. </Text>
            <br />
            <Text>Ms. Maricor P. Biag –</Text>{" "}
            <Link href="mailto:mpbiag@stocktransfer.com.ph">
              mpbiag@stocktransfer.com.ph
            </Link>
            <br />
            <br />
            <Text>Through Personal Service: </Text>
            <br />
            <Text strong>STOCK TRANSFER SERVICE, INC. </Text>
            <br />
            <Text>Unit 34-D Rufino Pacific Tower </Text>
            <br />
            <Text>6784 Ayala Avenue, Makati City, 1226 </Text>
            <br />
            <Text>Philippines </Text>
            <br />
            <br />
            <Text>Telephone. : (632) 5310-1343 </Text>
            <br />
            <Text>Fax : (632) 8403-2414 </Text>
            <br />
            <Text>Contact Persons : Ms. Maricor P. Biag –</Text>{" "}
            <Link href="mailto:mpbiag@stocktransfer.com.ph">
              mpbiag@stocktransfer.com.ph
            </Link>
            <br />
            <br />
            <Text>
              For the purpose of validation, the Stockholder must include the
              following in transmitting the completed and signed proxy form:
            </Text>
            <ol type="a">
              <li className="tabbed">Full name of contact person; </li>
              <li className="tabbed">
                Phone or mobile number of contact person;{" "}
              </li>
              <li className="tabbed">
                Scanned copy of valid government-issued ID of the Stockholder
                and his/her appointed proxy (if not the Chairman of the
                Company); and{" "}
              </li>
              <li className="tabbed">
                For corporate Stockholders, scanned copy of Secretary’s
                Certificate or Board Resolution authorizing the representative
                to act as the proxy.
              </li>
              <li className="tabbed spacing">
                For Stockholders holding ‘scripless’ shares, or shares held
                under a PCD Participant/Broker, a duly executed Secretary’s
                Certificate showing the authority of the representative to sign
                on behalf of the PCD Participant/Broker, and (2) a duly
                accomplished proxy or certificate of shareholdings issued by the
                Broker. Stockholders must coordinate with their brokers for the
                execution of this type of proxy. A Stockholder may instruct his
                broker to directly send a copy of the executed proxy to the
                Company, or he may send the copy of the executed proxy.
              </li>
            </ol>
          </li>
          <li className="tabbed spacing">
            <Text strong underline>
              TABULATION OF VOTES
            </Text>
            <br />
            <Text>
              Thereafter, the stock transfer agent of the Company shall tabulate
              the votes cast in absentia and by proxy. The results shall be
              verified by the Company’s external auditors, Punongbayan &amp;
              Araullo.
            </Text>
            <br />
            <br />
            <Text>
              The total votes made in absentia and by proxy, as well as the
              number of shares represented by the same, shall be announced
              during the 2022 SSM.{" "}
            </Text>
            <br />
            <br />
          </li>
          <li className="tabbed">
            <Text strong underline>
              PARTICIPATION IN THE 2022 SSM THROUGH REMOTE COMMUNICATIONS
            </Text>
            <br />
            <ol type="1">
              <li className="tabbed spacing">
                The Stockholders may attend the meeting on{" "}
                <Text strong>20 December 2022, at 1:00 P.M.</Text>, through the
                following link:{" "}
                <Link
                  href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_NmMyNWRlOTAtZmYzNC00ODlmLTgzOGUtODA1MTdmOTY5N2E1%40thread.v2/0?context=%7B%22Tid%22%3A%22036b84b7-26b8-441d-87c1-f3590d3f2ed1%22%2C%22Oid%22%3A%22adac7404-bd6e-427b-bf7b-722639c45b6f%22%2C%22IsBroadcastMeeting%22%3Atrue%2C%22role%22%3A%22a%22%7D&btype=a&role=a"
                  target="_blank"
                  underline
                >
                  Megawide 2022 SSM
                </Link>
                . The 2022 SSM shall be broadcasted live via Microsoft Teams,
                which may be accessed either through a web browser or the
                Microsoft Teams application.{" "}
              </li>
              <li className="tabbed spacing">
                The Stockholders who have not voted in absentia or submitted
                their proxies may still attend the 2022 SSM through the link
                provided above. However, to be included in the determination of
                the quorum, they must notify the stock transfer agent of the
                Company of their intention to attend the 2022 SSM by emailing
                the Company’s stock transfer agent at{" "}
                <Link href="mailto:mpbiag@stocktransfer.com.ph">
                  mpbiag@stocktransfer.com.ph
                </Link>{" "}
                by{" "}
                <Text strong style={{ fontStyle: "italic" }}>
                  2:00 P.M. of 20 December 2022
                </Text>
                . Such Stockholders must provide or attach in the email the
                requirements listed in Section I (1) (a) or I (1) (b), as the
                case may be, in order to be validated.{" "}
              </li>
              <li className="tabbed spacing">
                In view of the foregoing, the quorum for the 2022 SSM shall be
                determined based on the following:
                <ol type="a">
                  <li className="tabbed">
                    The Stockholders who were validated and voted in absentia;{" "}
                  </li>
                  <li className="tabbed">
                    The Stockholders who submitted their proxy forms and were
                    validated; and{" "}
                  </li>
                  <li className="tabbed">
                    The Stockholders who notified the Corporate Secretary of
                    their intention to attend the 2022 SSM and were validated.{" "}
                  </li>
                </ol>
              </li>
              <li className="tabbed">
                During the 2022 SSM, Stockholders will be given the opportunity
                to raise any questions or comments, by submitting the same in a
                chat box that will be made available to them throughout the live
                broadcast. The Company shall acknowledge, read out loud, and
                address such questions or comments.
                <br />
                <br />
                The Stockholders are, however, encouraged to furnish all
                questions, concerns, or comments to the Company prior to the
                2022 SSM, by emailing the same to the stock transfer agent of
                the Company at 
                <Link href="mailto:mpbiag@stocktransfer.com.ph">
                  mpbiag@stocktransfer.com.ph
                </Link>{" "}
                and/or to the Corporate Secretary at{" "}
                <Link href="mailto:corporatesecretary@megawide.com.ph">
                  corporatesecretary@megawide.com.ph
                </Link>{" "}
                by{" "}
                <Text strong style={{ fontStyle: "italic" }}>
                  2:00 P.M. of 19 December 2022.
                </Text>
                . These questions, concerns, or comments shall be answered
                during the 2022 SSM. Any unanswered questions shall be addressed
                via email.{" "}
              </li>
              <br />
            </ol>
          </li>
          <li className="tabbed">
            <Text strong underline>
              Documents
            </Text>
            <br />
            <ol type="1">
              <li className="tabbed">
                <Link
                  href="https://firebasestorage.googleapis.com/v0/b/mcc-stockholders-meeting.appspot.com/o/2022%20SSM%20Proxy%20DIS%20(Individual%20and%20Corporate%20Stockholder).pdf?alt=media&token=d4fb505e-20d1-4fbe-b7b1-f4df2e0d5c2b"
                  target="_blank"
                  underline
                >
                  Proxy Form (Individual and Corporate Stockholder)
                </Link>
              </li>
              <li className="tabbed">
                <Link
                  href="https://firebasestorage.googleapis.com/v0/b/mcc-stockholders-meeting.appspot.com/o/2022%20SSM%20Proxy%20DIS%20(PCD%20Participant).pdf?alt=media&token=5a33fa07-d124-4fdb-895f-4d5c8eebdb1f"
                  target="_blank"
                  underline
                >
                  Proxy Form (PCD Participant/Broker)
                </Link>
              </li>
              <li className="tabbed">
                <Link
                  href="https://firebasestorage.googleapis.com/v0/b/mcc-stockholders-meeting.appspot.com/o/HLD.%20LEG.%202022%20SSM%20Notice%20and%20Agenda.%202022%2005%2024.pdf?alt=media&token=21e473be-d8ff-4387-a2ff-5e9cbed96d1a"
                  target="_blank"
                  underline
                >
                  Notice and Agenda
                </Link>
              </li>
              <li className="tabbed">
                <Link
                  href="https://firebasestorage.googleapis.com/v0/b/mcc-stockholders-meeting.appspot.com/o/Megawide%20Construction%20Corporation_2022%20SSM%20DIS_17%20November%202022.pdf?alt=media&token=e624a846-ba95-40eb-b596-abbb4bf7b2b4"
                  target="_blank"
                  underline
                >
                  Definitive Information Statement
                </Link>
              </li>
              <li className="tabbed">
                <Link
                  href="https://firebasestorage.googleapis.com/v0/b/mcc-stockholders-meeting.appspot.com/o/Megawide%20Construction%20Corporation_2021%20Amended%20Annual%20Report_27%20June%202022.pdf?alt=media&token=15e4703a-27bc-4697-a882-052fe551f334"
                  target="_blank"
                  underline
                >
                  SEC Form 17-A
                </Link>{" "}
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default Landing;
